import { memo, useMemo } from "react";

import type * as FormModelType from "@/components/features/dialog/re-onboarding-request/model/type";

import { Button } from "@/components/ui/button/button";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import { useHandleForm } from "./hooks";

type Props = {
	viewModel: FormModelType.ReOnboardingRequestFormModel["ViewModel"];
	onSetViewModel: (viewModel: FormModelType.ReOnboardingRequestFormModel["ViewModel"]) => void;
	onSendReOnboardingRequest: () => void;
};

export const ReOnboardingRequestForm = memo(({ viewModel, onSetViewModel, onSendReOnboardingRequest }: Props) => {
	const { handleChangeUpdatedEmail, handleChangeMessage } = useHandleForm(viewModel, onSetViewModel);

	const disabled = useMemo(() => viewModel.hasError, [viewModel.hasError]);

	return (
		<form className="space-y-4">
			<InputTextField
				label="ご連絡先メールアドレス"
				type="email"
				value={viewModel.updatedEmail.value}
				placeholder="info@chillnn.com"
				errorMessage={viewModel.updatedEmail.error}
				handleChange={handleChangeUpdatedEmail}
			/>

			<TextAreaField
				label="自由記入欄"
				value={viewModel.message.value}
				errorMessage={viewModel.message.error}
				handleChange={handleChangeMessage}
			/>

			<div className="text-center">
				<Button
					type="button"
					disabled={disabled}
					variant="default"
					size="lg"
					onClick={onSendReOnboardingRequest}
				>
					送信
				</Button>
			</div>
		</form>
	);
});
